/**
 * Sticky add-to-cart: visible when the main PDP submit control is outside the viewport.
 * Relies on global subscribe / PUB_SUB_EVENTS from constants.js + pubsub.js (theme layout).
 */
(function () {
  function syncStickyButton(mainBtn, stickyBtn) {
    if (!mainBtn || !stickyBtn) return;
    stickyBtn.disabled = mainBtn.disabled;
    const aria = mainBtn.getAttribute('aria-disabled');
    if (aria) stickyBtn.setAttribute('aria-disabled', aria);
    else stickyBtn.removeAttribute('aria-disabled');

    const src = mainBtn.querySelector('span');
    const dst = stickyBtn.querySelector('span');
    if (src && dst) dst.textContent = src.textContent;
  }

  function initBar(bar) {
    const sectionId = bar.dataset.sectionId;
    if (!sectionId) return;

    const mainBtn = document.getElementById(`ProductSubmitButton-${sectionId}`);
    const stickyBtn = bar.querySelector('[data-sticky-atc-submit]');
    if (!mainBtn || !stickyBtn) {
      bar.remove();
      return;
    }

    syncStickyButton(mainBtn, stickyBtn);

    const observer = new IntersectionObserver(
      (entries) => {
        const intersecting = entries[0] && entries[0].isIntersecting;
        if (intersecting) {
          bar.removeAttribute('data-visible');
          bar.setAttribute('aria-hidden', 'true');
        } else {
          bar.setAttribute('data-visible', '');
          bar.setAttribute('aria-hidden', 'false');
        }
      },
      { root: null, threshold: 0, rootMargin: '0px 0px 12px 0px' }
    );
    observer.observe(mainBtn);

    const onVariantChange = () => {
      window.requestAnimationFrame(() => syncStickyButton(mainBtn, stickyBtn));
    };

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
    }

    const mo = new MutationObserver(onVariantChange);
    mo.observe(mainBtn, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.product-sticky-atc[data-section-id]').forEach(initBar);
  });
})();
